import { scrollTo } from "./scrollTo";

const InternalLinks = function (options) {
	"use strict";

	const _self = this;
	const settings = options;

	function bindEvents() {
		document.querySelectorAll('a[href^="#"]').forEach((el) => {
			el.addEventListener("click", handleClick);
		});
	}

	function handleClick(e) {
		if (
			e.currentTarget.hash.length <= 1 ||
			!document.querySelector(e.currentTarget.hash)
		)
			return;

		e.preventDefault();

		scrollTo(document.querySelector(e.currentTarget.hash));
	}

	function init() {
		bindEvents();

		return _self;
	}

	return init();
};

export { InternalLinks };
